<template>
  <Container>
    <Card>
      <Grid>
        <GridItem :gridSpan="12">
          <HeadingMedium
            :class="$style.headerBorder"
            hasMargin
          >
            {{ enrollmentInfo.title }}
          </HeadingMedium>
        </GridItem>
        <GridItem
          :gridSpan="4"
        >
          <Card
            :class="[$style.cardMarginRight, $style.cardHeight]"
            type="neutral"
          >
            <HeadingMedium
              :class="$style.googleHeaderIcon"
              hasMargin
            >
              <Icon
                :class="$style.firstcard"
                icon="android"
                :scale="1.5"
              />
              <span :class="$style.marginLeft">{{ enrollmentInfo.enrollmentfirstCard.title }}</span>
            </HeadingMedium>
            <ParagraphBody
              bodySize="standard"
              hasMargin
              weight="normal"
            >
              <MarkdownInline :mdTemplate="enrollmentInfo.enrollmentfirstCard.text" />
            </ParagraphBody>
          </Card>
        </GridItem>
        <GridItem
          :gridSpan="4"
        >
          <Card
            :class="[$style.cardMarginBoth, $style.cardHeight]"
            type="success"
          >
            <HeadingMedium
              :class="$style.googleHeaderIcon"
              hasMargin
            >
              <Icon
                :class="$style.secondcard"
                icon="key"
                :scale="1.5"
              />
              <span :class="$style.marginLeft">
                {{ enrollmentInfo.enrollmentsecondCard.title }}
              </span>
            </HeadingMedium>
            <ParagraphBody
              bodySize="standard"
              hasMargin
              weight="normal"
            >
              <ul
                v-for="line in enrollmentInfo.enrollmentsecondCard.text"
                :key="line"
                :class="$style.listMargin"
              >
                <li>{{ line }}</li>
              </ul>
            </ParagraphBody>
          </Card>
        </GridItem>
        <GridItem
          :gridSpan="4"
        >
          <Card
            :class="[$style.cardMarginLeft, $style.cardHeight]"
            type="neutral"
          >
            <HeadingMedium
              :class="$style.googleHeaderIcon"
              hasMargin
            >
              <Icon
                :class="$style.thirdcard"
                icon="award"
                :scale="1.5"
              />
              <span :class="$style.marginLeft">{{ enrollmentInfo.enrollmentthirdCard.title }}</span>
            </HeadingMedium>
            <ParagraphBody
              bodySize="standard"
              hasMargin
              weight="normal"
            >
              <ul
                v-for="line in enrollmentInfo.enrollmentthirdCard.text"
                :key="line"
                :class="$style.listMargin"
              >
                <li>{{ line }}</li>
              </ul>
            </ParagraphBody>
          </Card>
        </GridItem>
      </Grid>
      <HeadingExtraSmall
        :class="$style.headingMarginTop"
        hasMargin
        weight="semibold"
      >
        {{ enrollmentInfo.text }}
      </HeadingExtraSmall>
      <ParagraphBody
        bodySize="standard"
        hasMargin
        weight="normal"
      >
        <Grid>
          <GridItem :gridSpan="7">
            <ol :class="$style.listPaddingLeft">
              <li
                :class="$style.listMarginLeftBottom"
              >
                <MarkdownInline :mdTemplate="enrollmentInfo.instruction.startClickButton" />
              </li>
              <li
                :class="$style.listMarginLeftBottom"
              >
                <MarkdownInline :mdTemplate="enrollmentInfo.instruction.signInGoogleAccount" />
              </li>
              <li
                :class="$style.listMarginLeftBottom"
              >
                <MarkdownInline :mdTemplate="enrollmentInfo.instruction.enterBusinessName" />
              </li>
              <li
                :class="$style.listMarginLeftBottom"
              >
                <MarkdownInline :mdTemplate="enrollmentInfo.instruction.enterContactDetails" />
              </li>
              <li
                :class="$style.listPaddingLeft"
              >
                <MarkdownInline :mdTemplate="enrollmentInfo.instruction.completeRegistration" />
              </li>
            </ol>
          </GridItem>
          <GridItem :gridSpan="5">
            <IconButton
              :class="$style.iconBottomPosition"
              icon="externalLink"
              iconPosition="right"
              text="Begin Enrollment  "
              type="primary"
              @click="handleEnrolledButton()"
            />
          </GridItem>
        </Grid>
      </ParagraphBody>
    </Card>
  </Container>
</template>

<script>
import {
  AndroidEmmConsts,
} from 'client/util/Constants';
import {
  Card,
  Container,
  Grid,
  GridItem,
  HeadingExtraSmall,
  HeadingMedium,
  Icon,
  IconButton,
  MarkdownInline,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';

export default {
  name: 'GoogleEmmWelcome',

  components: {
    Card,
    Container,
    Grid,
    GridItem,
    HeadingExtraSmall,
    HeadingMedium,
    Icon,
    IconButton,
    MarkdownInline,
    ParagraphBody,
  },

  data: () => ({
    enrollmentInfo: AndroidEmmConsts.androidEmmEnrollmentText,
    enterpriseToken: null,
    pollCount: 0,
    pollTimer: null,
    signupUrlName: '',
  }),

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    async createEnterprise() {
      try {
        await GoogleMdmApi.postEnterprise({
          enrollmentToken: this.enterpriseToken,
          signupUrlName: this.signupUrlName,
        });
        this.triggerSuccessNotification({
          title: 'Success',
          message: 'Registration successful.',
        });
        this.$emit('enrollmentComplete');
      } catch (err) {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to register.',
        });
      }
    },

    async handleEnrolledButton() {
      try {
        const data = await GoogleMdmApi.getSignUpUrl();
        if (data) {
          this.signupUrlName = data.name;
          const callback = '#/mdm/google';
          const win = window.open(data.url);
          this.pollTimer = setInterval(() => {
            try {
              if (win.closed) {
                clearInterval(this.pollTimer);
              } else if (win.document.URL.indexOf(callback) !== -1) {
                const params = (new URL(win.document.location)).searchParams;
                this.enterpriseToken = params.get('enterpriseToken');
                this.createEnterprise();
                win.close();
                clearInterval(this.pollTimer);
              }
            } catch (err) {
              this.pollCount += 1;
            }
          }, 500);
        }
      } catch (e) {
        this.pollCount += 1;
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to register.',
        });
      }
    },
  },
};
</script>

<style module>
.headerBorder {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer);
}

.listPaddingLeft {
  padding-left: var(--jc-spacer);
}

.listMarginLeftBottom {
  margin-bottom: var(--jc-spacer);
  padding-left: var(--jc-spacer);
}

.iconBottomPosition {
  display: flex;
  float: right;
  top: 85%;
}

.iconBottomPosition span span {
  margin-left: var(--jc-spacer-small) !important;
}

.iconBottomPosition span span svg {
  height: 0.625rem !important;
  width: 0.625rem !important;
}

.googleHeaderIcon .firstcard svg {
  fill: var(--jcGrey400);
  margin-top: var(--jc-spacer-small);
  position: absolute;
}

.googleHeaderIcon .secondcard svg {
  fill: var(--jcBrand);
  margin-top: var(--jc-spacer-small);
  position: absolute;
}

.googleHeaderIcon .thirdcard svg {
  fill: var(--jcGrey400);
  margin-top: var(--jc-spacer-small);
  position: absolute;
}

.headingMarginTop {
  margin-top: 2.063rem !important;
}

.marginLeft {
  margin-left: 3.25rem;
}

.cardHeight {
  min-height: 17.5rem;
}

.cardMarginLeft {
  margin-left: 0.313rem;
}

.cardMarginRight {
  margin-right: 0.313rem;
}

.cardMarginBoth {
  margin-left: 0.188rem;
  margin-right: 0.188rem;
}

.listMargin {
  margin-bottom: var(--jc-spacer-x-small);
  margin-top: var(--jc-spacer-x-small);
  padding-left: var(--jc-spacer);
}
</style>
